module.exports = __webpack_public_path__ + "static/media/cssCases.26319ebd.png";